// src/components/planes/PlanesCard.js
import React from 'react';

const PlanesCard = ({ plan, onSeleccionar, esAdmin }) => {
  const getColorByTipo = (tipo) => {
    return tipo === 'suscripcion' ? 'var(--color-secundario)' : 'var(--color-primario)';
  };

  const getBordeByTipo = (tipo) => {
    return tipo === 'suscripcion' ? '2px solid var(--color-acento)' : '1px solid rgba(108,92,231,0.3)';
  };

  return (
    <div 
      className={`plan-card ${plan.tipo}`}
      style={{ borderLeft: getBordeByTipo(plan.tipo) }}
    >
      <div className="plan-header">
        <span className="plan-icon">{plan.icono}</span>
        <h3>{plan.nombre}</h3>
        {plan.tipo === 'suscripcion' && (
          <span className="plan-badge">🔄 Mensual</span>
        )}
      </div>

      <div className="plan-precio">
        <span className="moneda">$</span>
        <span className="cantidad">{plan.precio_mxn}</span>
        <span className="periodo">{plan.tipo === 'suscripcion' ? '/mes' : ''}</span>
      </div>

      <div className="plan-beneficios">
        <div className="beneficio">
          <span className="beneficio-icon">⚡</span>
          <span className="beneficio-texto">{plan.krums} Krums</span>
        </div>
        <div className="beneficio">
          <span className="beneficio-icon">🖼️</span>
          <span className="beneficio-texto">{plan.imagenes} imágenes</span>
        </div>
        <div className="beneficio">
          <span className="beneficio-icon">💰</span>
          <span className="beneficio-texto">${(plan.precio_mxn / plan.krums).toFixed(2)}/Krum</span>
        </div>
      </div>

      <p className="plan-descripcion">{plan.descripcion}</p>

      <button 
        className={`btn-plan ${plan.tipo}`}
        onClick={() => onSeleccionar(plan)}
        style={{ background: getColorByTipo(plan.tipo) }}
      >
        {plan.tipo === 'suscripcion' ? 'Suscribirse' : 'Comprar'}
      </button>

      {esAdmin && (
        <div className="plan-admin">
          <small>ID: {plan.id} | Orden: {plan.orden}</small>
        </div>
      )}
    </div>
  );
};

export default PlanesCard;